import Logo from "./Logo";
import { useEffect } from "react";

const Footer = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.iubenda.com/iubenda.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <footer className="border-t border-border py-12">
      <div className="container">
        <div className="cadence-wordmark" aria-hidden="true">CoachOS<span>↗</span></div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <Logo size={28} />
            <span className="font-bold text-foreground">CoachOS</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <a
              href="https://www.iubenda.com/privacy-policy/64553210"
              className="iubenda-black iubenda-noiframe iubenda-embed hover:text-foreground transition-colors"
              title="Politique de confidentialité"
            >
              Confidentialité
            </a>
            <a
              href="https://www.iubenda.com/privacy-policy/64553210/cookie-policy"
              className="iubenda-black iubenda-noiframe iubenda-embed hover:text-foreground transition-colors"
              title="Politique relative aux Cookies"
            >
              Cookies
            </a>
            <a href="/logiciel-coach-sportif" className="hover:text-foreground transition-colors">Logiciel coach sportif</a>
            <a href="/application-coach-sportif" className="hover:text-foreground transition-colors">Application coach sportif</a>
            <a href="/blog" className="hover:text-foreground transition-colors">Blog</a>
            <a href="/mentions-legales" className="hover:text-foreground transition-colors">Mentions légales</a>
            <a href="/#contact" className="hover:text-foreground transition-colors">Contact</a>
          </div>

          <p className="text-sm text-muted-foreground">
            © 2026 CoachOS. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
